import toggleSidebar from './toggleSidebar';
import toggleHeader from './toggleHeader';
import postError from './postError';
import getServiceTypes from './getServiceTypes';
import getLinkPreview from "@/store/shared/actions/getLinkPreview";

export default {
  toggleSidebar,
  toggleHeader,
  postError,
  getServiceTypes,
  getLinkPreview,
};
